module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/5.2-template-list.07e01844.png";